module.exports = __webpack_public_path__ + "static/media/CONSTRUCTION 3.9604975b.jpg";